import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { resolveGameDetailsBasePath, type GameDetailsBasePathResult } from '../../utils/games/gameDetailsBasePath';

export const useGameDetailsBasePath = (): GameDetailsBasePathResult => {
  const { pathname } = useLocation();

  return useMemo(() => resolveGameDetailsBasePath(pathname), [pathname]);
};
